import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, CalendarDays } from "lucide-react";
import { api, IMAGES, coverSrc } from "../lib/api";
import { Reveal } from "./Reveal";

const fmtDate = (d) => new Date(d).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" });

export const ArticleCard = ({ a, delay = 0 }) => (
  <Reveal delay={delay}>
    <Link to={`/conseils/${a.slug}`} data-testid={`article-card-${a.slug}`} className="group block h-full card-soft overflow-hidden rounded-2xl border border-zinc-200 bg-white shadow-sm">
      <div className="relative h-44 overflow-hidden">
        <img src={coverSrc(a)} alt={a.title} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-700" />
        <span className="absolute top-3 left-3 rounded-full bg-white/90 px-3 py-1 text-[11px] font-semibold text-primary">{a.category}</span>
      </div>
      <div className="p-6">
        <div className="flex items-center gap-1.5 text-xs text-zinc-400 mb-2"><CalendarDays className="h-3.5 w-3.5" /> {fmtDate(a.date)}</div>
        <h3 className="text-xl font-display font-medium text-zinc-900 leading-snug">{a.title}</h3>
        <p className="text-sm text-zinc-600 mt-2 leading-relaxed line-clamp-2">{a.excerpt}</p>
        <span className="mt-4 inline-flex items-center gap-1.5 text-sm text-zinc-600 group-hover:text-primary transition-colors">Lire l'article <ArrowUpRight className="h-4 w-4" /></span>
      </div>
    </Link>
  </Reveal>
);

export default function ArticlesTeaser({ title = "Conseils & actualités", subtitle, limit = 3, className = "bg-white" }) {
  const [articles, setArticles] = useState([]);
  useEffect(() => { api.get("/articles").then((r) => setArticles(r.data.slice(0, limit))).catch(() => {}); }, [limit]);
  if (!articles.length) return null;
  return (
    <section className={`relative z-10 py-24 sm:py-32 border-t border-zinc-200 ${className}`} data-testid="articles-teaser">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <Reveal>
            <p className="overline mb-4">Le blog du serrurier</p>
            <h2 className="text-4xl sm:text-5xl font-display font-semibold tracking-tighter max-w-2xl leading-[1.02] text-zinc-900">{title}</h2>
            {subtitle && <p className="text-zinc-500 mt-4 max-w-xl">{subtitle}</p>}
          </Reveal>
          <Reveal delay={0.1}><Link to="/conseils" className="text-sm text-zinc-600 hover:text-primary flex items-center gap-1.5 link-underline">Tous les articles <ArrowUpRight className="h-4 w-4" /></Link></Reveal>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {articles.map((a, i) => <ArticleCard key={a.slug} a={a} delay={(i % 3) * 0.07} />)}
        </div>
      </div>
    </section>
  );
}
